export default "__VITE_ASSET__DLkYF52s__"